
function offcanvasToggle(action) {
    var mobileNavigation = $(".js-offcanvas-navigation");
    var mobileNavigationInner = $(".js-offcanvas-inner");

    if (action == "close") {
        console.log("close");
        mobileNavigation.css("width", 0);
    }

    if (action == "open") {
        mobileNavigationInner.show();
        mobileNavigation.css("width", "100%");
    }
}


$(document).ready(function () {
    
    $(".js-offcanvas-trigger").on("click", function () {
        offcanvasToggle("open");
    });
    $(".js-offcanvas-offset").on("click", function () {
        offcanvasToggle("close");
    });
    $(".js-offcanvas-close").on("click", function () {
        offcanvasToggle("close");
    });
});